export const SET_SELECTION = "SET_SELECTION";
export const SET_SELECTED_OPTION = "SET_SELECTED_OPTION";
export const SET_IT_COMMENT = "SET_IT_COMMENT"; 

export const setSelection = (isSelected) => ({
    type: SET_SELECTION,
    payload: isSelected,
});

export const setSelectedOption = (option) => ({
    type: SET_SELECTED_OPTION,
    payload: option,
});

export const setITComment = (comment) => ({ 
    type: SET_IT_COMMENT,
    payload: comment,
});
